import { Chip, Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';
import { ISchoolMonitoringEventSimpleProps } from '../../../services/Events/SchoolMonitoringEventService/types';
import { getEventTargetData } from '../../../services/Events/SchoolMonitoringEventService/utils';

export const ClassCell = ({ event }: { event: ISchoolMonitoringEventSimpleProps }) => {
  const { className } = getEventTargetData(event);
  
  const rawClassName = event.studentRecognition?.className;
  const hasRealClass = rawClassName && rawClassName.trim() !== '';

  if (hasRealClass) {
    return (
      <Tooltip title={className} arrow placement="top">
        <Chip 
          label={className} 
          size="medium" 
          variant="filled" 
          color="default" 
          sx={{ 
            fontWeight: 500, 
            maxWidth: '100%', 
            backgroundColor: '#c29191', 
            color: '#fcf7f7',
            '& .MuiChip-label': {
                display: 'block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '275px'
            }
          }}
        />
      </Tooltip>
    );
  }

  return (
    <Typography 
      variant="caption" 
      color="text.secondary" 
      sx={{ fontStyle: 'normal',whiteSpace: 'nowrap' }}
    >
      {t(className!)}
    </Typography>
  );
};